import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Services
import { RelationEditService } from '../../service/relations-edit.service';
import { LayoutProposta } from '../../../models/layout-proposta';

@Component({
	selector: 'app-relations-edit',
	templateUrl: './relations-edit.component.html',
	providers: [
		RelationEditService,
		HttpModule
	]
})

export class RelationTypeEditComponent implements OnInit {
	relationtype: FormGroup;
	public economicGroupClassifications:any[] =[];
	ID: string;
	Nome: string;
	Descricao: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;
	private sub: any;
	public permissoes: any[] = [];
	public layoutProposta: LayoutProposta;

	constructor(fb: FormBuilder, private relationEditService: RelationEditService, private router: Router, private route: ActivatedRoute) {
	
		this.layoutProposta = new LayoutProposta();
		this.relationtype = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(64)])],
			'Classificacao' : [0,Validators.compose([Validators.min(1)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getEconomicGroupClassifications();
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.relationEditService.getRelations(this.ID).subscribe(result => {
				var updaterelation = result.Result;
				console.log("dados",updaterelation);
				this.relationtype.setValue({
					ID: updaterelation.ID,
					Nome: updaterelation.Nome,
					Classificacao: updaterelation.ClassificacaoGrupoEconomicoID,
					Ativo: updaterelation.Ativo
				});
			})
		}, error => {
			console.log(error);

		});
	}
	getEconomicGroupClassifications() {
		this.relationEditService.getEconomicGroupClassifications().subscribe(result => {
		  //this.economicGroupClassifications = result;
		  this.economicGroupClassifications = result.Result;
		  console.log(this.economicGroupClassifications);
		}, error => {
		  console.log(error);
		});
	  }

	editrelation() {
		this.relationEditService.updateRelations(this.relationtype.value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/relacoes');

		}, error => {
			console.log(error);

		});
	}

	cancelInsertRelation() {
		this.router.navigateByUrl('/relacoes');
	}

}



// WEBPACK FOOTER //
// ./src/app/relations/component/relations-edit/relations-edit.component.ts